import React, { useState } from "react";
import PropTypes from "prop-types";

import Modal from "core/Modal";
import Button from "core/Button";
import FormInput from "core/FormInput";

import { NameModalCancelButton, ModalChildrenContainer } from "./styles";

const PhotoshootNameChangeModal = ({
    defaultShootName,
    open,
    onClose,
    updateShootName
}) => {
    const [hasFinalShootName, updateFinalShootName] = useState(
        defaultShootName
    );

    const heading = "Name This Photo Shoot";

    const handleInputChange = value => {
        updateFinalShootName(value);
    };

    const handleSave = e => {
        e.preventDefault();

        updateShootName(hasFinalShootName);
        onClose();
    };

    const handleClose = () => {
        onClose();
        // wait on resetting the input value until modal is closed so user doesnt see it switch back:
        setTimeout(() => updateFinalShootName(defaultShootName), 500);
    };

    const footerChildren = (
        <>
            <Button onClick={e => handleSave(e)}>Save</Button>

            <NameModalCancelButton onClick={handleClose}>
                Cancel
            </NameModalCancelButton>
        </>
    );

    return (
        <Modal
            open={open}
            onClose={onClose}
            handleClose={onClose}
            heading={heading}
        >
            <ModalChildrenContainer>
                <FormInput
                    placeholderText={heading}
                    labelText={heading}
                    value={hasFinalShootName}
                    onChange={value => handleInputChange(value)}
                />

                {footerChildren}
            </ModalChildrenContainer>
        </Modal>
    );
};

PhotoshootNameChangeModal.propTypes = {
    defaultShootName: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    updateShootName: PropTypes.func.isRequired
};

export default PhotoshootNameChangeModal;
